/* @flow weak */
import { compact } from 'lodash';
import createChainedFunction from 'utils/createChainedFunction';
import cx from 'classnames';
import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';
import React, { PropTypes } from 'react';

import './styles/Tabs.scss';

class Tabs extends React.Component {
  static propTypes = {
    tabActive: React.PropTypes.number,
    tabAlign: React.PropTypes.oneOf(['left', 'right', 'center']),
    tabHeaderClass: React.PropTypes.string,
    children: React.PropTypes.node.isRequired,
    onTabChange: React.PropTypes.func,
    type: React.PropTypes.oneOf(['border', 'button', 'bar']),
    buttonSize: PropTypes.oneOf(['large', 'medium', 'small', 'xsmall']),
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  };

  static defaultProps = {
    tabAlign: 'left',
    tabHeaderClass: '',
    type: 'border',
    buttonSize: 'medium',
    orientation: 'horizontal',
  };

  state = {
    tabActive: this.props.tabActive || 0,
  };

  componentWillReceiveProps({ tabActive }) {
    if (typeof tabActive === 'number') {
      this.setState({ tabActive });
    }
  }

  setActive = (index, e) => {
    this.setState({ tabActive: index });
    e.preventDefault();

    if (this.props.onTabChange) {
      this.props.onTabChange(index);
    }
  };

  getChildren = () => {
    return compact(this.props.children);
  };

  renderBar = (title) => {
    return (
      <div className="Tabs-bar">
        {title}
      </div>
    );
  };

  renderMenuItems = () => {
    const { type: tabType, buttonSize } = this.props;
    const menuItems = this.getChildren().map((panel, index) => {
      if (!panel) {
        return null;
      }

      if (tabType === 'button') {
        return (
          <Button
            level={this.state.tabActive === index ? 'primary' : 'secondary'}
            size={buttonSize}
            className="Tabs--buttons-button"
            key={index}
            onClick={createChainedFunction(panel.props.onClick, this.setActive.bind(this, index))}
            eventElementName={panel.props.eventElementName}>
            {panel.props.title}
          </Button>
        );
      } else if (tabType === 'bar') {
        return (
          <Button
            color={this.state.tabActive === index ? 'brand' : 'thunder'}
            level={this.state.tabActive === index ? 'primary' : 'secondary'}
            size={buttonSize}
            className="Tabs--bar-button"
            key={index}
            full
            onClick={createChainedFunction(panel.props.onClick, this.setActive.bind(this, index))}
            eventElementName={panel.props.eventElementName}>
            {panel.props.title}
          </Button>
        );
      } else {
        const { selectedBorderColor: borderColor } = panel.props;

        return (
          <li
            className={cx('Tabs--border-item', {
              'Tabs--border-item--hidden': panel.props.hidden,
              'Tabs--border-item-vertical': this.props.orientation === 'vertical',
            })}
            key={index}>
            <Link
              href="#"
              className={cx('Tabs--border-item-link',
                (this.state.tabActive === index) && 'active',
                (borderColor) && `Tabs--border-item-link--${borderColor}`,
                panel.props.className)
              }
              onClick={createChainedFunction(panel.props.onClick, this.setActive.bind(this, index))}
              eventElementName={panel.props.eventElementName}>
              {panel.props.title}
            </Link>
          </li>
        );
      }
    });

    if (this.props.type === 'button') {
      return (
        <nav
          className={cx('Tabs Tabs--buttons', {
            'Tabs--buttons-vertical': this.props.orientation === 'vertical',
          })}>
          {menuItems}
        </nav>
      );
    } else if (this.props.type === 'bar') {
      return (
        <nav className={cx('Tabs', 'Tabs--bar', this.props.tabHeaderClass)}>
          {menuItems}
        </nav>
      );
    } else {
      return (
        <nav
          className={cx('Tabs', 'Tabs--border', this.props.tabHeaderClass)}
          style={{ textAlign: this.props.tabAlign }}>
          <ul className="Tabs-list Tabs--border-list">
            {menuItems}
          </ul>
        </nav>
      );
    }
  };

  render() {
    return (
      <div className={this.props.className}>
        {this.renderMenuItems()}
        {this.getChildren()[this.state.tabActive]}
      </div>
    );
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Tabs.jsx